import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDropzone } from "react-dropzone";
import "../dropzone/dropzone.css";
import Dropdown from "../../Icon/Dropdown";
import {
  Box,
  FormHelperText,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FontFamily } from "../theme/fontFamily";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import { ThemeColor } from "../theme/color";
import Delete from "../../Icon/Delete";
import { UploadFileService } from "../../Redux/service/FileService";
import { DownloadDoneOutlined } from "@mui/icons-material";
import { DownCircleOutlined } from "@ant-design/icons";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  //   marginTop: 16
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid black",
  //   marginTop: 10,
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};
const Previews = forwardRef((props, ref) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const showDescText = props.showDescText ? false : true;
  // console.log(props,"line 58585858")

  const onDrop = useCallback(
    async (acceptedFiles) => {
      setError(null);
      // // Check if limit exceeded
      // if (props?.max3 && files.length >= 3) {
      //   window.alert("Only 3 image files are allowed.");
      //   return;
      // }

      // Limit the number of files added
      const remainingSlots = props?.max3
        ? 3 - files.length
        : acceptedFiles.length;
      const limitedFiles = acceptedFiles.slice(0, remainingSlots);

      const docsFile = [];

      try {
        const uploadPromises = limitedFiles.map(async (file) => {
          const formData = new FormData();
          formData.append("file", file);

          const response = await UploadFileService(formData);
          if (response.status === 200) {
            docsFile.push({
              ...response.data.result,
              preview: URL.createObjectURL(file),
            });
          }
        });

        await Promise.all(uploadPromises);
      } catch (err) {
        console.error("uploadPhotoPost : error ", err);
      }

      const newFiles = [...files, ...docsFile];
      setFiles(newFiles);
      props?.handleMydropzoneFile(docsFile, newFiles);
    },
    [files, props?.handleMydropzoneFile, props?.max3]
  );

  const onDropRejected = () => {
    setError("You can only upload up to 3 images.");
  };

  const remainingSlots = props?.max3 ? 3 - files.length : undefined;

  const { getRootProps, getInputProps } = useDropzone({
    accept: props.max3 ? { "image/*": [] } : undefined,
    multiple: props.multiple ? false : true,
    maxFiles: remainingSlots,
    onDrop,
    onDropRejected,
  });

  // const { getRootProps, getInputProps } = useDropzone({
  //   // accept: {
  //   //   "image/*": [],
  //   // },
  //   multiple: true,
  //   onDrop: async (acceptedFiles) => {
  //     // setFiles(...files,
  //     //   ...acceptedFiles.map((file) =>
  //     //     Object.assign(file, {
  //     //       preview: URL.createObjectURL(file),
  //     //     })
  //     //   )
  //     // );
  //     // console.log(acceptedFiles, "dropzone clg");
  //     var docsFile = [];

  //     try {
  //       const uploadPromises = acceptedFiles.map(async (file) => {
  //         const formData = new FormData();
  //         formData.append("file", file);
  //         //  console.log(formData, "form data");

  //         const response = await UploadFileService(formData);
  //         if (response.status === 200) {
  //           //   console.log(response.data.result);
  //           docsFile.push({
  //             ...response.data.result,
  //             preview: URL.createObjectURL(file),
  //           });
  //         }
  //       });

  //       // Wait for all uploads to complete
  //       await Promise.all(uploadPromises);
  //     } catch (err) {
  //       //("uploadPhotoPost : err ", err);
  //     }
  //     const updatedFiles = [
  //       ...files,
  //       ...acceptedFiles.map((file) =>
  //         Object.assign(file, {
  //           preview: URL.createObjectURL(file),
  //         })
  //       ),
  //     ];
  //     //  console.log(docsFile);
  //     //(docsFile, "docs file");
  //     setFiles((prevFiles) => [...prevFiles, ...docsFile]);

  //     // props?.handleMydropzoneFile(docsFile);

  //     //   setFiles([...files, ...acceptedFiles]);
  //   },
  // });

  const downloadFile = async (file) => {
    // console.log(file, "url of file in my drop zone");
    // const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    // const response = await fetch(`${proxyUrl}${file}`);
    // const blob = await response.blob();
    // const blobUrl = URL.createObjectURL(blob);
    // const link = document.createElement("a");
    // link.href = blobUrl;
    // link.setAttribute("download", "Group.png");
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    // URL.revokeObjectURL(blobUrl);

    window.open(file, "_blank", "noopener noreferrer");
  };

  useEffect(() => {
    // This will be called whenever `files` is updated
    if (files.length > 0) {
      props?.handleMydropzoneFile(files);
    }
  }, [files]);
  const someFunction = (values) => {
    setFiles(values);
    props.handleMydropzoneFile(values);
  };

  const someEditFunction = () => {
    setFiles(props.initialValue || []);
    // props.handleMydropzoneFile(props.initialValue);
  };

  useImperativeHandle(ref, () => ({
    someFunction,
    someEditFunction,
  }));

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
    props.handleMydropzoneFile(newFiles);
  };

  const previewFile = (file) => {
    window.open(file.url, "_blank");
  };

  const thumbs = files?.map((file, index) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img
          src={file.preview}
          style={img}
          // Revoke data uri after image is loaded
          onLoad={() => {
            URL.revokeObjectURL(file.preview);
          }}
        />
        <button onClick={() => handleRemove(index)}>Remove</button>
      </div>
    </div>
  ));

  useEffect(() => {
    //(props.initialValue, "nonnoon");
    // `|| []`: an absent initialValue used to make `files` undefined, and the
    // very next render read files.length.
    setFiles(props.initialValue || []);
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    // return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, []);

  const FileHandler = (data) => {
    if (data?.url.split(".").pop() === "xlsx") {
      let urlParts = data?.url.split("/");
      let fullFileName = urlParts[urlParts.length - 1];
      return (
        <div className="mt-2 d-flex align-items-center">
          {/* <div className="filename-icon">
            <img
              src="/assest/folderpng/excel.png"
              alt="file icon"
              className="w-100 h-100"
            ></img>
          </div> */}
          <a
            href={data.url}
            download={fullFileName}
            style={{ textDecoration: "none", color: "blue" }}
          >
            <Typography
              className="px-2"
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W400}
              fontSize={fontSize.h4.medium}
              color={ThemeColor.BLACK}
              align="left"
            >
              {fullFileName}
            </Typography>
          </a>
        </div>
      );
    } else if (data?.url.split(".").pop() === "pdf") {
      let urlParts = data?.url.split("/");
      let fullFileName = urlParts[urlParts.length - 1];
      return (
        <div className="mt-2 d-flex align-items-center">
          {/* <div className="filename-icon">
            <img
              src="/assest/folderpng/pdf.png"
              alt="file icon"
              className="w-100 h-100"
            ></img>
          </div> */}
          <a
            href={data?.url}
            target="_blank"
            download={fullFileName}
            style={{ textDecoration: "none", color: "blue" }}
          >
            <Typography
              className="px-2"
              fontFamily={FontFamily.Poppins}
              fontWeight={fontWeight.W400}
              fontSize={fontSize.h4.medium}
              color={ThemeColor.BLACK}
              align="left"
            >
              {fullFileName}
            </Typography>
          </a>
        </div>
      );
    } else {
      return (
        <div className="mt-2">
          <Typography
            className="px-2"
            fontFamily={FontFamily.Poppins}
            fontWeight={fontWeight.W400}
            fontSize={fontSize.h4.medium}
            color={ThemeColor.BLACK}
            onClick={() => downloadFile(data?.url)}
            align="left"
          >
            {/* <img
              onClick={() => downloadFile(data?.url)}
              src={data?.url}
              style={{
                // display:"none",
                width: "20px",
                height: "20px",
              }}
              alt="chatimg"
            /> */}
            {data?.name}
          </Typography>

          {/* <img
            onClick={() => downloadFile(data)}
            src={data}
            style={{
              width: "100px",
              height: "100px",
            }}
            alt="chatimg"
          /> */}
        </div>
      );
    }
  };

  // `fillHeight` makes the card stretch to its grid row instead of being sized
  // by its contents, so a slot holding a file is not twice the height of an
  // empty one sitting next to it. Opt-in: every other page keeps the old sizing.
  const fillHeight = Boolean(props.fillHeight);

  return (
    <section
      className="my-dropzone-container"
      style={
        fillHeight
          ? {
              height: "100%",
              minHeight: props.minHeight || 200,
              display: "flex",
              flexDirection: "column",
            }
          : undefined
      }
    >
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} />
        <div className="my-dropzone-content">
          <div>
            <Dropdown />
          </div>

          <Typography
            // fontFamily={FontFamily.Lato}
            // fontSize={fontSize.h4.large}
            // fontWeight={fontWeight.W400}
            sx={{
              fontWeight: 520,
              fontSize: "1rem",
              letterSpacing: "0.00938em",
              fontFamily: "Lato !important",
              textAlign: "center",
              // Reserve two lines: otherwise "English Test Scorecard" wraps and
              // makes its card taller than "Consent" beside it.
              ...(fillHeight ? { minHeight: "2.6em", lineHeight: 1.3 } : {}),
            }}
          >
            {/* Upload your document here */}
            {props.mainText ? props.mainText : "Upload Document"}
          </Typography>
          {/* <Typography
            fontFamily={FontFamily.Lato}
            color={ThemeColor.GREY}
            fontSize={fontSize.h4.medium}
            align="center"
          >
            will create new folder with university name and save you file in it{" "}
          </Typography> */}
          {showDescText && (
            <Typography
              fontFamily={FontFamily.Lato}
              color={ThemeColor.GREY}
              fontSize={fontSize.h4.medium}
              align="center"
            >
              {/* will create new folder with university name and save you file in
                it{" "} */}
              {props?.text
                ? props.text
                : "Folder will be auto-created by university name"}
            </Typography>
          )}
          {error && <p style={{ color: "red", marginTop: 8 }}>{error}</p>}
          <FormHelperText component="div">{props.helperText}</FormHelperText>
        </div>
      </div>
      {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
      <Box
        className="w-100"
        sx={
          fillHeight
            ? {
                // Take the leftover space rather than jumping from 10px to
                // 200px the moment a file lands.
                flex: 1,
                minHeight: 0,
                mt: files.length > 0 ? 1 : 0,
                overflowY: "auto",
                overflowX: "hidden",
              }
            : {
                height:
                  files.length > 0 ? (props?.height ? props.height : 200) : 10,
                overflowY: "auto",
                overflowX: "hidden",
              }
        }
      >
        <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
          {files?.map((file, index) => {
            const getFileName = (url) => {
              if (!url) return "Document";
              const parts = url.split("/");
              return decodeURIComponent(parts[parts.length - 1]);
            };
            const fileName = file.name || getFileName(file.url);
            const isExcel = file.url?.toLowerCase().endsWith(".xlsx") || file.url?.toLowerCase().endsWith(".xls");
            const isPdf = file.url?.toLowerCase().endsWith(".pdf");
            const isImage = file.url?.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/i);

            let iconElement = "📄";
            if (isExcel) iconElement = "📊";
            else if (isPdf) iconElement = "📕";
            else if (isImage) iconElement = "🖼️";

            return (
              <Box
                key={index}
                component="li"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px 12px",
                  marginBottom: "8px",
                  borderRadius: "6px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#fafafa",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    borderColor: ThemeColor.LIGHTPURPLE,
                  },
                }}
              >
                {/* File Icon */}
                <Box
                  sx={{
                    fontSize: "1.3rem",
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {iconElement}
                </Box>

                {/* File Name */}
                <Box sx={{ flexGrow: 1, minWidth: 0, marginRight: "12px" }}>
                  {/* Ellipsised in a narrow card, so the full name has to be
                      reachable somehow. */}
                  <Tooltip title={fileName} placement="top">
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W500}
                    fontSize="0.8rem"
                    color={ThemeColor.BLACK}
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      cursor: "pointer",
                      "&:hover": {
                        color: ThemeColor.LIGHTPURPLE,
                        textDecoration: "underline",
                      }
                    }}
                    onClick={() => {
                      if (isExcel || isPdf) {
                        window.open(file.url, "_blank", "noopener noreferrer");
                      } else {
                        downloadFile(file.url);
                      }
                    }}
                  >
                    {fileName}
                  </Typography>
                  </Tooltip>
                </Box>

                {/* Action Buttons */}
                <Box sx={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  <IconButton
                    size="small"
                    onClick={() => previewFile(file)}
                    sx={{
                      color: "#616161",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e0e0e0",
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "#eeeeee",
                        color: ThemeColor.BLACK,
                      }
                    }}
                  >
                    <VisibilityIcon style={{ width: "16px", height: "16px" }} />
                  </IconButton>

                  {props.deleteShow && (
                    <IconButton
                      size="small"
                      onClick={() => handleRemove(index)}
                      sx={{
                        color: "#d32f2f",
                        backgroundColor: "#ffebee",
                        border: "1px solid #ffcdd2",
                        padding: "4px",
                        "&:hover": {
                          backgroundColor: "#ef9a9a",
                          color: "#c62828",
                        }
                      }}
                    >
                      <Delete style={{ width: "16px", height: "16px" }} />
                    </IconButton>
                  )}
                </Box>
              </Box>
            );
          })}
        </ul>
      </Box>
    </section>
  );
});
// function Previews(props, ref) {}

export default Previews;
